import SignUpForm from 'components/modules/auth/SignUpForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

const SignUp = () => {
  document.title = process.env.REACT_APP_NAME + ' | Sign Up';
  return (
    <AuthCardLayout className="card-sign-up">
      <SignUpForm layout="card" />
    </AuthCardLayout>
  );
};

export default SignUp;
